<template>
  <b-container fluid>
    <page-title><h2><router-link :to="{ name: 'CurrencyTypeList' }" class="nav-link">Waluty</router-link>/Nowa waluta</h2></page-title>

    <div class="col page-element">
      <alert-loading v-if="loading"></alert-loading>
      <div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>

      <CurrencyTypeForm v-if="!loading" :handle-submit="create" :values="item" :errors="violations" ></CurrencyTypeForm>
    </div>
  </b-container>
</template>

<script>
  import CurrencyTypeForm from './Form.vue';
  import { createNamespacedHelpers } from 'vuex';

  const { mapGetters } = createNamespacedHelpers('currencytype/create');

  export default {
    components: {
      CurrencyTypeForm
    },
    data: function() {
      return {
        item: {}
      }
    },
    created(){
      this.$store.dispatch('currencytype/create/reset');
    },
    computed: mapGetters({
      error: 'error',
      loading: 'loading',
      created: 'created',
      violations: 'violations',
    }),
    methods: {
      create: function(item) {
        this.$store.dispatch('currencytype/create/create', item);
      }
    },
    watch: {
      created: function (created) {
        if (created) {
          this.$router.push({ name: 'CurrencyTypeUpdate', params: { id: created['id']} });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Create.vue?45399c8f